/*
  LFDL Cart Add-ons
  - Permet de cocher une ou plusieurs options
  - Bouton "Rajouter au panier" : ajoute tout ce qui est coché
  - Bouton "Ajouter" sur chaque option : ajoute uniquement cette option
  - Utilise routes.cart_add_url / routes.cart_url (compatible multi-langues/prefix)
*/

(() => {
  "use strict";

  const root = document.querySelector("[data-lfdl-cart-addons]");
  if (!root) return;

  const toastEl = root.querySelector("[data-lfdl-addon-toast]");
  const btnAll = root.querySelector("[data-lfdl-addon-add]");
  const itemBtns = root.querySelectorAll("[data-lfdl-addon-cta]");
  const addonItems = root.querySelectorAll("[data-lfdl-addon-item]");

  const getRoute = (key, fallback) => {
    try {
      if (typeof routes !== "undefined" && routes && routes[key]) return routes[key];
    } catch (e) {}
    if (window.routes && window.routes[key]) return window.routes[key];
    return fallback;
  };

  const cartAddUrl = getRoute("cart_add_url", "/cart/add.js");
  const cartUrl = getRoute("cart_url", "/cart");

  let busy = false;

  const showToast = (message) => {
    if (!message) return;
    if (!toastEl) {
      console.warn("[LFDL cart addons]", message);
      return;
    }
    toastEl.textContent = message;
    toastEl.classList.add("is-visible");
    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(() => toastEl.classList.remove("is-visible"), 2600);
  };

  const setButtonLoading = (button, isLoading) => {
    if (!button) return;
    if (isLoading) {
      button.disabled = true;
      button.classList.add("is-loading");
      if (!button.dataset.lfdlOrigText) button.dataset.lfdlOrigText = button.textContent.trim();
      button.textContent = "Ajout...";
    } else {
      button.disabled = false;
      button.classList.remove("is-loading");
      if (button.dataset.lfdlOrigText) button.textContent = button.dataset.lfdlOrigText;
    }
  };

  const getCheckedVariantIds = () => {
    const ids = [];
    addonItems.forEach((item) => {
      const check = item.querySelector("[data-lfdl-addon-check]");
      if (!check || !check.checked) return;
      const variantId = item.getAttribute("data-variant-id");
      if (variantId) ids.push(String(variantId));
    });
    return Array.from(new Set(ids));
  };

  const addVariants = async (variantIds) => {
    const items = (variantIds || []).filter(Boolean).map((id) => ({ id, quantity: 1 }));
    if (!items.length) return;

    const res = await fetch(cartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = data?.description || data?.message || "Impossible d’ajouter l’option au panier.";
      throw new Error(msg);
    }
    return data;
  };

  const goCart = () => {
    try {
      window.location.href = cartUrl;
    } catch (e) {
      window.location.reload();
    }
  };

  const handleAddAll = async () => {
    if (busy) return;
    const ids = getCheckedVariantIds();
    if (!ids.length) {
      showToast("Sélectionnez au moins une option.");
      return;
    }
    busy = true;
    setButtonLoading(btnAll, true);
    try {
      await addVariants(ids);
      goCart();
    } catch (err) {
      showToast(err?.message || "Erreur.");
    } finally {
      setButtonLoading(btnAll, false);
      busy = false;
    }
  };

  const handleAddSingle = async (button) => {
    if (busy) return;
    const item = button?.closest("[data-lfdl-addon-item]");
    if (!item) return;
    const variantId = item.getAttribute("data-variant-id");
    if (!variantId) {
      showToast("Option invalide.");
      return;
    }
    const check = item.querySelector("[data-lfdl-addon-check]");
    if (check) check.checked = true;

    busy = true;
    setButtonLoading(button, true);
    try {
      await addVariants([String(variantId)]);
      goCart();
    } catch (err) {
      showToast(err?.message || "Erreur.");
    } finally {
      setButtonLoading(button, false);
      busy = false;
    }
  };

  if (btnAll) {
    btnAll.addEventListener("click", (e) => {
      e.preventDefault();
      handleAddAll();
    });
  }

  itemBtns.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      handleAddSingle(button);
    });
  });
})();
